/* eslint-disable angular/factory-name */
angular.module("digiexam.exam").factory(
	"Exam",
	function ExamService(
		$http,
		$filter,
		$location,

		DxQuestion,
		DxStudent,
		DxExternalToolSettings,
		GradingMatrix,
		DX_URLS,
		PermissionShareEnum,
		examStatus,
		dxSession,
		RoleTypeEnum,
		DX_GRADING_TYPES,
		DX_SPELLCHECKSETTING,
		DX_DURATION_SETTING,
		DX_TEXT_TO_SPEECH_SETTING,
		DX_IMMERSIVE_READER_SETTING,
		DX_USB_AUDIO_SETTING,
		DX_QUESTION_TYPE,

		dxLocalize
	) {
		"use strict";

		function getPercentage(part, whole) {
			if (part === 0 || whole === 0) {
				return 0;
			}
			return (part / whole) * 100;
		}

		function Exam(data) {
			var dirty = false;
			angular.extend(this, {
				// Helper properties

				isStudentsLoaded: false,
				isQuestionsLoaded: false,

				// Exam properties

				id: 0,
				at: new Date(),
				title: "",
				subject: "",
				courseId: 0,
				groupId: 0,
				parent: 0,
				ancestor: 0,
				about: "",
				aboutHTML: "",
				blank: true,
				open: false,
				duration: 0,
				durationSetting: 0,
				isArchived: false,
				publishedParts: 0,
				examStatus: examStatus.NOT_STARTED,
				start: "0001-01-01T00:00:00Z",
				stop: "0001-01-01T00:00:00Z",
				created: "0001-01-01T00:00:00Z",
				modified: "0001-01-01T00:00:00Z",
				anonymous: false,
				rightToLeft: false,
				spellcheckAllowed: false,
				spellcheckSetting:
					DX_SPELLCHECKSETTING.SpellcheckSettingAllowOverride,
				textToSpeechAllow: false,
				textToSpeechSetting:
					DX_TEXT_TO_SPEECH_SETTING.TextToSpeechSettingAllowOverride,
				usbAudioAllowed: false,
				usbAudioSetting:
					DX_USB_AUDIO_SETTING.UsbAudioSettingAllowOverride,
				immersiveReaderAllowed: false,
				immersiveReaderSetting:
					DX_IMMERSIVE_READER_SETTING.ALLOW_OVERRIDE,
				randomizedQuestions: false,
				randomizedAlternatives: false,
				lockedQuestionSequence: false,
				openBook: false,
				tags: [],
				students: [],
				questions: [],
				gradingType: DX_GRADING_TYPES.SCORE,
				gradingMatrixId: 0,
				gradingMatrix: null,
				editorVersion: 0,
				allowExternalPaste: false,
				remoteProctoringEnabled: false,
				externalToolSettings: [],

				// Public functions

				isDirty: function isDirty() {
					for (var j = 0; j < this.questions.length; j++) {
						var q = this.questions[j];
						if (q.isDirty()) {
							return true;
						}
					}

					return dirty;
				},

				setDirty: function setDirty(state) {
					// Only flag dirty as false on children, they are responsible for setting it to true themselves
					if (!state) {
						if (this.questions != null) { // eslint-disable-line eqeqeq, no-eq-null
							for (var j = 0; j < this.questions.length; j++) {
								var q = this.questions[j];
								q.setDirty(state);
							}
						}
					}

					dirty = state;
				},

				startDateTime: function startDateTime() {
					var started = new Date(this.start);

					if (started.valueOf() > 0) {
						return $filter("date")(started, "short");
					}

					return "-";
				},

				isPartiallyGraded: function isPartiallyGraded() {
					for (var j = 0; j < this.students.length; j++) {
						var s = this.students[j];

						if (s.isFinalGradeSet()) {
							return true;
						}

						for (var k = 0; k < s.answers.length; k++) {
							var a = s.answers[k];
							if (a.isGraded()) {
								return true;
							}
						}
					}
					return false;
				},

				getNumGradedAnswers: function getNumGradedAnswers(
					includeFinalGrade
				) {
					if (includeFinalGrade == null) { // eslint-disable-line eqeqeq, no-eq-null
						includeFinalGrade = false; // eslint-disable-line no-param-reassign
					}

					if (!this.isStudentsLoaded) {
						return 0;
					}

					var num = 0;
					for (var j = 0; j < this.students.length; j++) {
						var s = this.students[j];

						if (s.state === 2) {
							num += s.getNumGradedAnswers(includeFinalGrade);
						}
					}

					return num;
				},

				getNumTotalAnswers: function getNumTotalAnswers(
					includeFinalGrade
				) {
					if (!this.isStudentsLoaded) {
						return 0;
					}

					var numQuestions = this.questions.length;

					if (includeFinalGrade) {
						numQuestions++;
					}

					return this.students.reduce(function reduce(
						numAnswers,
						student
					) {
						// eslint-disable-next-line no-param-reassign
						return (numAnswers +=
							student.state === 2 ? numQuestions : 0); // eslint-disable-line no-param-reassign, no-return-assign
					},
					0);
				},

				getPercentageNumGradedAnswers:
					function getPercentageNumGradedAnswers(includeFinalGrade) {
						var numGradedAnswers =
							this.getNumGradedAnswers(includeFinalGrade);
						var numTotalAnswers =
							this.getNumTotalAnswers(includeFinalGrade);

						return getPercentage(numGradedAnswers, numTotalAnswers);
					},

				getNumFinalGradesSet: function getNumFinalGradesSet() {
					if (!this.isStudentsLoaded) {
						return 0;
					}

					var num = 0;
					for (var j = 0; j < this.students.length; j++) {
						var s = this.students[j];
						if (s.state === 2 && s.isFinalGradeSet()) {
							num++;
						}
					}
					return num;
				},

				getNumTotalFinalGrades: function getNumTotalFinalGrades() {
					return this.students.reduce(function reduce(
						numTotal,
						student
					) {
						if (student.state === 2) {
							return ++numTotal; // eslint-disable-line no-param-reassign
						}

						return numTotal;
					},
					0);
				},

				getPercentageNumFinalResultsSet:
					function getPercentageNumFinalResultsSet() {
						return getPercentage(
							this.getNumFinalGradesSet(),
							this.getNumTotalFinalGrades()
						);
					},

				setPublished: function setPublished(
					publishedParts,
					notifications
				) {
					var self = this;

					return $http.
						post(DX_URLS.get("examSetPublished"), {
							examId: this.id,
							publishedParts: publishedParts,
							notifications: notifications,
						}).
						then(function success(response) {
							if (response.status !== 200) {
								return false;
							}

							self.publishedParts = publishedParts;
							self.examStatus = response.data.examStatus;

							return true;
						});
				},

				libraryShareWith: function libraryShareWith(email) {
					var promise = $http.post(DX_URLS.get("share"), {
						objectId: this.id,
						email: email,
						permission: PermissionShareEnum.LIBRARY_EXAM,
					});

					return promise.then(function success(response) {
						return response.data;
					});
				},

				gradingShareWith: function gradingShareWith(
					email,
					questionIds,
					studentIds
				) {
					var promise = $http.post(DX_URLS.get("share"), {
						objectId: this.id,
						email: email,
						permission: PermissionShareEnum.GRADING,
						questionIds: questionIds,
						studentIds: studentIds,
					});

					return promise.then(function success(response) {
						return response.data;
					});
				},

				notAllQuestionsHaveAbilities:
					function notAllQuestionsHaveAbilities() {
						for (var j = 0; j < this.questions.length; j++) {
							var question = this.questions[j];
							if (question.matrixAbilityMask.length === 0) {
								return true;
							}
						}

						return false;
					},

				parseExam: function parseExam() {
					for (var i = 0; i < this.questions.length; i++) {
						var question = this.questions[i];

						if (question.parseBody) {
							question.parseBody();
						}
					}
				},

				getErrorList: function getErrorList() {
					var errors = [];

					if (this.title.length === 0) {
						errors.push({
							id: "examCreate-title",
							msg: dxLocalize.get("YouNeedToSetATitle"),
						});
					}

					if (this.subject.length === 0) {
						errors.push({
							id: "examCreate-subject",
							msg: dxLocalize.get("YouNeedToSetASubject"),
						});
					}

					if (this.questions.length === 0) {
						errors.push({
							id: "new-question",
							msg: dxLocalize.get("YouNeedToAddQuestions"),
						});
					}

					if (this.durationSetting > DX_DURATION_SETTING.OFF) {
						if (this.duration === 0) {
							errors.push({
								id: "time-limit",
								msg: dxLocalize.get(
									"ExamDuration.ErrorMessage"
								),
							});
						}
					}

					for (var j = 0; j < this.questions.length; j++) {
						var q = this.questions[j];
						q.isValid(errors, this.gradingType);
					}

					return errors;
				},

				getGrades: function getGrades(includeNonDigital) {
					if (includeNonDigital == null) { // eslint-disable-line eqeqeq, no-eq-null
						includeNonDigital = false; // eslint-disable-line no-param-reassign
					}

					var self = this;
					var conf = {
						params: {
							includeNonDigital: includeNonDigital,
						},
					};

					var getGradePromise = $http.get(
						"/exam/getgrading/" + this.id,
						conf
					);
					return getGradePromise.then(function success(response) {
						// TODO: DIRTY, NEED A NEAT CONSISTENT WAY TO COMMUNICATE ERRORS TO THE VIEW
						if (response.status !== 200) {
							return false;
						}

						var questions = [];

						if (response.data && response.data.questions) {
							for (
								var i = 0;
								i < response.data.questions.length;
								i++
							) {
								questions.push(
									new DxQuestion(
										response.data.questions[i].type,
										response.data.questions[i]
									)
								);
							}
						}

						self.questions = questions;
						self.isQuestionsLoaded = true;
						var students = [];

						if (response.data && response.data.students) {
							for (
								var j = 0;
								j < response.data.students.length;
								j++
							) {
								if (
									self.anonymous &&
									response.data.students[j].anonymousId
								) {
									response.data.students[j].name =
										dxLocalize.get(
											"StudentX",
											response.data.students[j].
												anonymousId
										);
								}

								students.push(
									new DxStudent(response.data.students[j])
								);
							}
						}

						students.forEach(function foreachStudent(student) {
							if (student.redactedPii) {
								student.name = dxLocalize.get(
									"RedactedPii.StudentName"
								);
								student.code = "";
							}
						});

						self.students = students;
						self.isStudentsLoaded = true;
						self.hasFinalGradeAccess =
							response.data.hasFinalGradeAccess;
						self.hasCreatorAccess = response.data.hasCreatorAccess;

						return {
							students: students,
							questions: questions,
						};
					});
				},

				startExam: function startExam() {
					var self = this;

					return $http.
						post("/exam/start/", {
							examId: this.id,
						}).
						then(function success(response) {
							if (response.status !== 200) {
								return false;
							}

							angular.extend(self, response.data);
							self.status = examStatus.ACTIVE;
							return self;
						});
				},

				stopExam: function stopExam() {
					return $http.
						post("/exam/stop/", {
							examId: this.id,
						}).
						then(
							function success(response) {
								return response.data;
							},
							function failed(response) {
								if (
									dxSession.getRole().roleType ===
									RoleTypeEnum.INVIGILATOR
								) {
									$location.url(DX_URLS.get("overview"));
								}
								return response.data;
							}
						);
				},

				move: function move(courseId, groupId) {
					return $http.
						post("/exam/move/", {
							examId: this.id,
							courseId: courseId,
							groupId: groupId,
						}).
						then(function success(response) {
							return response.data;
						});
				},

				addQuestion: function addQuestion(type) {
					var q = new DxQuestion(type);
					q.title =
						dxLocalize.get("Question") +
						" " +
						(this.questions.length + 1);

					if (
						q.type === DX_QUESTION_TYPE.SINGLE_CHOICE ||
						q.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE
					) {
						q.addAlternative();
						q.addAlternative();
						q.addAlternative();
					}

					return this.questions.push(q);
				},

				removeQuestion: function removeQuestion(questionIndex) {
					return this.questions.splice(questionIndex, 1);
				},

				isFirstQuestion: function isFirstQuestion(index) {
					return index === 0;
				},

				isLastQuestion: function isLastQuestion(index) {
					return index === this.questions.length - 1;
				},

				moveQuestion: function moveQuestion(currentIndex, newIndex) {
					if (
						!(
							this.questions[currentIndex] &&
							this.questions[newIndex]
						)
					) {
						return;
					}

					var movedQuestion = this.questions[currentIndex];
					this.questions[currentIndex] = this.questions[newIndex];
					this.questions[newIndex] = movedQuestion;
				},

				moveQuestionUp: function moveQuestionUp(currentIndex) {
					return this.moveQuestion(currentIndex, currentIndex - 1);
				},

				moveQuestionDown: function moveQuestionDown(currentIndex) {
					return this.moveQuestion(currentIndex, currentIndex + 1);
				},

				copyLastQuestionTemplate: function copyLastQuestionTemplate() {
					if (this.questions.length === 0) {
						return;
					}

					var src = this.questions[this.questions.length - 1];
					var dest = new DxQuestion(src.type, angular.copy(src));
					dest.id = 0;
					dest.title =
						dxLocalize.get("Question") +
						" " +
						(this.questions.length + 1);
					dest.notes = "";
					dest.about = "";

					if (
						dest.type === DX_QUESTION_TYPE.SINGLE_CHOICE ||
						dest.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE
					) {
						for (var j = 0; j < dest.alternatives.length; j++) {
							var a = dest.alternatives[j];
							a.title = "";
							a.right = false;
						}
					}

					if (dest.type === DX_QUESTION_TYPE.WORD_GAP) {
						var newQuestionHtml = this.randomizeIdSting(
							dest.bodyHTML
						);
						dest.bodyHTML = newQuestionHtml;
					}
					return this.questions.push(dest); // eslint-disable-line
				},

				randomizeIdSting: function randomizeIdSting(questionHtml) {
					// eslint-disable-next-line
					var tempEl = document.createElement("div");
					tempEl.innerHTML = questionHtml;
					var wordGaps = tempEl.querySelectorAll("span[dx-wg-id]");
					if (wordGaps.length) {
						var newIdArr = [];

						for (var i = 0; i < wordGaps.length; i++) {
							newIdArr = [];
							var id = wordGaps[i].getAttribute("dx-wg-id");

							// Create new IDs for copied mathfields
							var arrOfNumbers = id.split("-");

							for (var x = 0; x < arrOfNumbers.length; x++) {
								var arr = arrOfNumbers[x].split("");
								arr.sort(function sort() {
									return 0.5 - Math.random();
								});
								var newArr = arr.join("");
								newIdArr.push(newArr);
							}

							var newId = newIdArr.join("-");
							wordGaps[i].setAttribute("dx-wg-id", newId);
						}
					}
					return tempEl.innerHTML;
				},

				updateBlanksIds: function updateBlanksIds(question) {
					// eslint-disable-next-line
					var tempEl = document.createElement("div");
					tempEl.innerHTML = question.bodyHTML;
					var wordGaps = tempEl.querySelectorAll("span[dx-wg-id]");

					if (wordGaps.length) {
						for (var i = 0; i < wordGaps.length; i++) {
							if (question.blanks[i].guid) {
								var id = wordGaps[i].getAttribute("dx-wg-id");
								question.blanks[i].guid = id;
							}
						}
					}
				},

				copyQuestion: function copyQuestion(question) {
					// Need to do an angular copy of the question and remove the id, otherwise it will
					// fail when copying an question to the same exam as you are currently editing
					var questionCopy = angular.copy(question);

					questionCopy.id = 0;
					var questionTypesWithAlternatives = [
						DX_QUESTION_TYPE.SINGLE_CHOICE,
						DX_QUESTION_TYPE.MULTIPLE_CHOICE,
					];

					// Set alternative's ids to 0.
					if (
						questionTypesWithAlternatives.indexOf(
							questionCopy.type
						) !== -1
					) {
						for (
							var j = 0;
							j < questionCopy.alternatives.length;
							j++
						) {
							var alternative = questionCopy.alternatives[j];
							alternative.id = 0;
						}
					}

					if (question.type === DX_QUESTION_TYPE.WORD_GAP) {
						var newQuestionHtml = this.randomizeIdSting(
							question.bodyHTML
						);
						question.bodyHTML = newQuestionHtml;
						this.updateBlanksIds(question);
					}

					return this.questions.push(
						new DxQuestion(question.type, questionCopy)
					);
				},

				maxScore: function maxScore() {
					var sum = 0;
					if (this.questions) {
						for (var j = 0; j < this.questions.length; j++) {
							var question = this.questions[j];
							if (question.maxScore != null) { // eslint-disable-line eqeqeq, no-eq-null
								sum += parseFloat(question.maxScore);
							}
						}
					}
					return sum;
				},

				syncToLMS: function syncToLMS() {
					return $http.
						post("/lti/sync/grades/", {
							examId: this.id,
							finalResultTranslation:
								dxLocalize.get("FinalGrade"),
							feedBackTranslation: dxLocalize.get(
								"FeedbackFromYourTeacher"
							),
						}).
						then(success, failed);

					function success(response) {
						return response.data.students;
					}

					function failed(response) {
						return response;
					}
				},

				/**
				 * Returns the exam ID formatted as:
				 * 12 34 5
				 * 12 34
				 * 12
				 * 1
				 * @returns {string} Formatted exam id string
				 */
				formattedId: function formattedId() {
					var eIdString = String(this.id);

					if (eIdString.length <= 2) {
						return eIdString;
					}

					var eIdArray = eIdString.match(/.{1,2}/g) || [];
					return eIdArray.join(" ");
				},

				isTemplate: function isTemplate() {
					return this.parent === 0;
				},

				isUnplanned: function isUnplanned() {
					return (
						!this.isTemplate() &&
						this.examStatus === examStatus.NOT_STARTED
					);
				},

				isGroupExam: function isGroupExam() {
					return this.groupId !== 0 && this.courseId !== 0;
				},

				hasOwnerRights: function hasOwnerRights() {
					var role = dxSession.getRole();

					if (role.roleType === RoleTypeEnum.TEACHER) {
						return dxSession.getUser().id === this.userId;
					} else if (role.roleType === RoleTypeEnum.ADMIN) {
						return role.organizationId === this.organizationId;
					}

					return false;
				},

				getStepLocale: function getStepLocaleKey() {
					switch (this.examStatus) {
						case examStatus.NOT_STARTED:
						case examStatus.PLANNED:
							if (this.isArchived) {
								return "Exams.ScheduledArchived";
							}
							return "Exams.Scheduled";
						case examStatus.ACTIVE:
							if (this.isArchived) {
								return "Exams.OngoingArchived";
							}
							return "Exams.Ongoing";
						case examStatus.NOT_GRADED:
							if (this.isArchived) {
								return "Exams.UngradedArchived";
							}
							return "Exams.Ungraded";
						case examStatus.GRADED:
							if (this.isArchived) {
								return "Exams.GradedArchived";
							}
							return "Exams.Graded";
						case examStatus.PUBLISHED:
							if (this.isArchived) {
								return "Exams.PublishedArchived";
							}
							return "Exams.Published";
						default:
							return "Exams.Library";
					}
				},

				addExternalToolSettings: function addExternalToolSettings(
					settings
				) {
					this.externalToolSettings.push(settings);
				},

				removeExternalToolSettings: function removeExternalToolSettings(
					toolId
				) {
					this.externalToolSettings =
						this.externalToolSettings.filter(function filter(
							settings
						) {
							return settings.externalToolId !== toolId;
						});
				},

				isExternalToolEnabled: function isExternalToolEnabled(toolId) {
					return this.externalToolSettings.some(function someFn(
						settings
					) {
						return settings.externalToolId === toolId;
					});
				},

				getExternalToolSettings: function getExternalTool(toolId) {
					return this.externalToolSettings.find(function findFn(
						settings
					) {
						return settings.externalToolId === toolId;
					});
				},

				// Returns external tool settings on the exam whose corresponding external tools were deleted
				getDeletedExternalToolSettings:
					function getDeletedExternalToolSettings(
						availableExternalToolIds
					) {
						return this.externalToolSettings.filter(
							function filterFn(settings) {
								return (
									availableExternalToolIds.indexOf(
										settings.externalToolId
									) === -1
								);
							}
						);
					},
			});

			if (data != null) { // eslint-disable-line eqeqeq, no-eq-null
				if (data.questions != null) { // eslint-disable-line eqeqeq, no-eq-null, no-negated-condition
					for (var ii = 0; ii < data.questions.length; ii++) {
						data.questions[ii] = new DxQuestion(
							data.questions[ii].type,
							data.questions[ii]
						);
					}
				} else {
					// Kind of annoying, but the server keeps returning null on questions
					data.questions = [];
				}
				if (data.gradingMatrix) {
					data.gradingMatrix = new GradingMatrix(data.gradingMatrix);
				}

				if (data.externalToolSettings) {
					data.externalToolSettings = data.externalToolSettings.map(
						function mapFn(settings) {
							return new DxExternalToolSettings(settings);
						}
					);
				} else {
					data.externalToolSettings = [];
				}

				angular.extend(this, data);
			}

			this.isQuestionsLoaded =
				this.questions != null && this.questions.length > 0; // eslint-disable-line eqeqeq, no-eq-null

			// Always set current version explicitly.
			this.editorVersion = 2;
		}

		return Exam;
	}
);
